package team.platforma.auth_domain.use_cases

import team.platforma.auth_data.repository.AuthRepository
import team.platforma.auth_domain.model.AuthDomain
import team.platforma.wrapper.Response

class UserNetworkUseCase(private val repository: AuthRepository) {

    suspend fun auth(email: String, password: String): Response<AuthDomain> =
        repository.auth(email, password).transform {
            AuthDomain(
                account = AuthDomain.Account(
                    accountId = it.account.account_id,
                    createdAt = it.account.created_at,
                    email = it.account.email,
                    firstName = it.account.first_name,
                    isAdmin = it.account.is_admin,
                    lastName = it.account.last_name,
                    telegramChatId = it.account.telegram_chat_id
                ),
                jwt = AuthDomain.Jwt(
                    refreshToken = it.jwt.refreshToken,
                    refreshTokenExpires = it.jwt.refreshTokenExpires,
                    token = it.jwt.token,
                    tokenExpires = it.jwt.tokenExpires
                )
            )
        }

}